import { Observable } from "rxjs";
import { SCOPE } from "constants/action-types";
import siteConfig from "site-config";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { getRecordsFromSchema, normalizeData } from "lib/api";
import { BrandedLogin as BrandedLoginSchema } from "schemas/brand";
import { updateEntities } from "redux-query";

export const fetchBrandedLoginEpic = (action$, store) => {
    return action$
        .ofType(SCOPE.BRANDED_LOGIN.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((slug) => {
            return ajax({
                method: "GET",
                url: `${siteConfig.api}/brand/${slug}/custom-login`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        const records = getRecordsFromSchema(BrandedLoginSchema);
                        const result = normalizeData(response, BrandedLoginSchema, records);
                        return { error: false, entities: result.entities };
                    } else {
                        return { error: true, entities: null };
                    }
                })
                .flatMap(({ error, entities }) => {
                    if (!error) {
                        return [
                            {
                                type: SCOPE.BRANDED_LOGIN.COMPLETED,
                            },
                            updateEntities({
                                brandedLogin: (brandedLogin = {}) => {
                                    return {
                                        ...entities.brandedLogin,
                                    };
                                },
                            }),
                        ];
                    } else {
                        return [];
                    }
                })
                .catch((error) => {
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: SCOPE.BRANDED_LOGIN.COMPLETED,
                        }),
                    );
                });
        });
};
